// components/CalendarHub.js
//
// Kalender-tabblad van de verhuurder: schakelt tussen de Multi-kalender (alle
// gekozen woningen onder elkaar) en de Maandkalender (1 woning), met bovenaan
// een woningfilter. Bij maar 1 woning verdwijnt het filterbalkje vanzelf.
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropertyTimeline from './PropertyTimeline';
import PropertyCalendar from './PropertyCalendar';
import { PropertyFilter, usePropertySelection } from './PropertyFilter';
import './CalendarHub.css';

const MODE_KEY = 'ss_calendar_mode';

function CalendarHub({ properties, userRole }) {
  const { t } = useTranslation();
  const [mode, setModeState] = useState(() => {
    try { return localStorage.getItem(MODE_KEY) === 'month' ? 'month' : 'multi'; } catch (e) { return 'multi'; }
  });
  const setMode = (m) => {
    setModeState(m);
    try { localStorage.setItem(MODE_KEY, m); } catch (e) { /* stil */ }
  };

  const multi = usePropertySelection('ss_filter_calendar_multi_v2', properties, false);
  const month = usePropertySelection('ss_filter_calendar_month_v2', properties, true);
  const monthProperty = month.selectedProperties[0];

  return (
    <div className="cal-hub">
      <div className="cal-hub-toggle" role="tablist">
        <button type="button" role="tab" aria-selected={mode === 'multi'} className={mode === 'multi' ? 'active' : ''} onClick={() => setMode('multi')}>
          {t('propertyFilter.calendarMulti')}
        </button>
        <button type="button" role="tab" aria-selected={mode === 'month'} className={mode === 'month' ? 'active' : ''} onClick={() => setMode('month')}>
          {t('propertyFilter.calendarMonth')}
        </button>
      </div>

      {mode === 'multi' ? (
        <>
          <PropertyFilter properties={properties} selected={multi.selected} onChange={multi.setSelected} />
          <PropertyTimeline properties={multi.selectedProperties} userRole={userRole} />
        </>
      ) : (
        <>
          <PropertyFilter properties={properties} selected={month.selected} onChange={month.setSelected} single />
          {monthProperty && (
            <PropertyCalendar
              key={monthProperty.id}
              propertyId={monthProperty.id}
              propertyName={monthProperty.name}
              userRole={userRole}
              cleaningTier={monthProperty.cleaningTier}
              cleaningHours={monthProperty.cleaningHours}
              cleaningServices={monthProperty.cleaningServices}
            />
          )}
        </>
      )}
    </div>
  );
}

export default CalendarHub;
